import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  tokenValidation,
  assignPassword,
  clearAuthenticationResponse,
} from "../../../actions/auth.action.entry";

import {
  hasNumbers,
  hasLowerLetter,
  hasUpperLetter,
  hasSpecialCharacter,
  isCorrectLength,
  isCorrectMaxLength,
} from "../../../helpers/regex.helper";
import SimpleReactValidator from "simple-react-validator";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import Typography from "@material-ui/core/Typography";
import AuthenticationLayoutUko from "../../../components/AuthenticationLayoutUko/AuthenticationLayoutUko";
import CustomInput from "../../../components/AuthenticationLayoutUko/CustomInput";
//import PrimaryButtonUko from "../../../components/primaryButtonUko.component";
import ErrorBoxUko from "../../../components/errorBoxUko.component";
import Box from '@material-ui/core/Box';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles, styled } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { isEmpty } from "../../../utils/proprietaryHooks";
import { encryptionKey, encryptionIv } from "../../../config/config.entry";
import { reactValidatorOptions } from "../../../helpers/simpleReactValidator";
import { getVersionAppAction } from "../../../actions/applications.action";
import { Grid, InputAdornment, IconButton, useTheme, Button, CircularProgress } from "@material-ui/core";
import { Buffer } from 'buffer';
import CheckBoxIcon from "../../../components/IconsLibrary/CheckBoxIcon";
import CheckendBoxIcon from "../../../components/IconsLibrary/CheckendBoxIcon";

const OwnButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.buttonUko.buttonUkoBackgroundActive,
  width: "100%",
  height: "46px",
  display: "block",
  color: theme.buttonUko.buttonUkoBackgroundSuccess,
  fontSize: "20px",
  borderRadius: "6px !important",
  "&:hover": {
    backgroundColor: theme.buttonUko.buttonUkoBackgroundActive,
  },
  "& .MuiButton-label": {
    textTransform: "none",
  },

}));

const OwnLink = styled(Link)(({ theme }) => ({
  color: theme.palette.letter.color,
  marginBottom: '2px',
  textDecoration: 'underline',
  fontFamily: 'Montserrat',
  fontSize: '14px',
  fontWeight: 600,
  '&:hover': {
    color: theme.palette.letter.color,
    textDecoration: 'none',
  },
}));

const ChangePasswordUko = (props) => {
  const {
    appName,
    assignPassword,
    authReducer,
    tokenValidation,
    getVersionAppAction,
    getVersionApp,
    clearAuthenticationResponse,
    tenant,
  } = props
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const [showPassword, setShowPassword] = useState(true);
  const [showConfirmPassword, setShowConfirmPassword] = useState(true);
  const {
    control,
    watch,
  } = useForm({
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
  });
  const watchPassword = watch('password');
  const watchConfirmPassword = watch('confirmPassword');
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorBox, setErrorBox] =useState("");
  const [isErrorBox, setIsErrorBox]=useState(false);
  const [showButton, setShowButton] = useState(false);
  const [showIconNewPassword, setShowIconNewPassword] = useState(false);
  const [showIconConfirmPassword, setShowIconConfirmPassword] = useState(false);
  const [incorrectPasswords, setIncorrectPasswords]= useState(false);
  const [versionMessage, setVersionMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState({
    length: false,
    upper: false,
    lower: false,
    number: false,
    specialChar: false,
  });

  const [formState, setFormState] = useState({
    user: "",
    isNewUser: false,
    token: "",
    email: "",
    confirmpassword: "",
    newpassword: "",
    tokenValidation:false,
  });

  const loginValidator = new SimpleReactValidator(reactValidatorOptions);

  useEffect(() => {
    if (!watchPassword || !watchConfirmPassword) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  }, [watchPassword, watchConfirmPassword]);

  useEffect(() => {
    if (appName && appName !== "") {
      getVersionAppAction(appName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEmpty(getVersionApp)) {
      setVersionMessage(getVersionApp.version);
    }
  }, [getVersionApp]);

  useEffect(() => {
    try {
      var paramsChar = decodeURIComponent(window.location.search.substring(1));
      var aesjs = require("aes-js");
      var aesCbc = new aesjs.ModeOfOperation.cbc(encryptionKey, encryptionIv);
      var encryptedText = aesjs.utils.hex.toBytes(
        new Buffer(paramsChar || "", "base64").toString("hex")
      );
      var decryptedBytes = aesCbc.decrypt(encryptedText);
      var decryptedText = aesjs.utils.utf8
        .fromBytes(decryptedBytes)
        .replace(/(?:\\[rn]|[\r\n]+|[\000-\031\200-\377])+/g, "");

      if (paramsChar.trim() === "" || decryptedText.trim() === "") {
        history.push({
          pathname: "/Alert",
          state: {
            message: "El enlace no es válido.",
            pagename: "/Login",
          },
        });
        return;
      }

      var objParameters = JSON.parse(decryptedText);
      const email = JSON.parse(Buffer.from((objParameters.token).split('.')[1], 'base64').toString()).email;

      if(objParameters){
        setFormState({
          user: objParameters.user,
          isNewUser: objParameters.isNewUser,
          token: objParameters.token,
          email: email,
          oldpassword: "",
          confirmpassword:"",
          newpassword:""
        });
      }
    } catch (error) {
      console.error(error);
      history.push({
        pathname: "/Alert",
        state: {
          message: "Error al procesar el enlace.",
          pagename: "/Login",
        },
      });
    }
  }, [history])

  useEffect(() => {
    const validateToken = async () => {
      if (formState.user !== "" && formState.token !== "") {
        await tokenValidation(
          formState.user,
          formState.token,
          appName,
          history
        );
      }
    };
    if (!formState.tokenValidated) {
      validateToken().then(() => {
        setFormState((prevState) => ({ ...prevState, tokenValidated: true }));
      });
    }
  }, [formState, tokenValidation, appName, history]);

  useEffect(() => {
    if(authReducer.isInvalidToken.ok !== false){
      history.push({
        pathname: "/resendemail",
        state: {
          message: authReducer.isInvalidToken.message,
          messageType: 'INVALID_LINK',
          emailFromUser: formState.email,
          userName: formState.user,
        },
      });
    }
  }, [authReducer, history, formState, appName]);

  const setChangePassword = async (e) => {
    e.preventDefault();
    if (loginValidator.allValid()) {
      if (comparePasswords() === false) {
        setIsErrorBox(true);
        return;
      }

      const formData = {
        user: formState.user,
        password: password,
        token: formState.token,
        appname: appName
      };

      try {
        setLoading(true);
        await assignPassword(formData, history, tenant, formState.isNewUser);   
      } catch (error) {
        setLoading(false);
        setErrorBox(error.response.data.result.information);
        setIncorrectPasswords(true);
        setIsErrorBox(true);
      }
    } else {
      loginValidator.showMessages();
      setIsErrorBox(true);
    }
  };
  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setShowIconNewPassword(true);
    setIncorrectPasswords(false);
    setIsErrorBox(false);
    setErrorBox("")

    const errors = {
      length: isCorrectLength(newPassword, 12) && isCorrectMaxLength(newPassword, 16),
      upper: hasUpperLetter(newPassword),
      lower: hasLowerLetter(newPassword),
      number: hasNumbers(newPassword) ? true : false,
      specialChar: hasSpecialCharacter(newPassword),
    };

    setPassword(newPassword);
    setPasswordErrors(errors);
  };

  const handleConfirmPasswordChange = (event) => {
    setShowIconConfirmPassword(true)
    setIncorrectPasswords(false);
    setIsErrorBox(false);
    setErrorBox("")
    setConfirmPassword(event.target.value)
  };

  const comparePasswords = () => {
    if (password !== confirmPassword) {
      setErrorBox("Las contraseñas no coinciden.");
      setIncorrectPasswords(true);
      return false;
    } else {
      let passwordValidLength = isCorrectLength(password, 12) ? true : false;
      let passwordValidMaxLength = isCorrectMaxLength(password, 16) ? true : false;
      let passwordValidUpper = hasUpperLetter(password) ? true : false;
      let passwordValidLower = hasLowerLetter(password) ? true : false;
      let passValidNum = hasNumbers(password) ? true : false;
      let passValidChar = hasSpecialCharacter(password);

      if (passwordValidLength && passwordValidMaxLength && passwordValidUpper && passwordValidLower && passValidNum && passValidChar) {
        return true;
      } else {
        setErrorBox("La contraseña no cumple con los mínimos requeridos.");
        setIncorrectPasswords(true);
        return false;
      }
    }
  };

  const onLinkGoToLogin = () => {
    clearAuthenticationResponse();
  };
  
  return (
    <AuthenticationLayoutUko title={formState.isNewUser ? "Activar cuenta" : "Cambiar contraseña"} logoApp={formState.isNewUser ? theme.urlLogo.urlActivatePasswordlogo : theme.urlLogo.urlChangePasswordlogo} logoSignIn={theme.urlLogo.urlSignIn}>
      <form id="cambiarcontraseña-validation" autoComplete="off" onSubmit={(e)=> setChangePassword(e)}>
        <Grid container direction="column" style={{ marginTop: "40px", gap: "16px" }}>
          <Grid item xs={12} style={{ display:"flex", justifyContent:"center", alignItems:"center" }}>
            <CustomInput
              label="Nueva contraseña*"
              name="password"
              control={control}
              error={incorrectPasswords ? {
                password: {
                  message: "",
                  type: "required"
                },
                confirmPassword: {
                  message: "",
                  type: "required"
                }
              } : {}}
              type={showPassword ? "password" : "text"}
              onValidate={(e)=>handlePasswordChange(e)}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              InputPropsParam={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onMouseDown={() => setShowPassword(!showPassword)}
                      size="small"
                    >
                      {showIconNewPassword && (showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />)}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              classes={classes.typeInput}
              autoFocus={false}
              inputProps={{
                style: !showPassword ? {
                  fontFamily: 'Montserrat',
                } : {
                  letterSpacing: "3px",
                  WebkitTextStroke: "0.5px black",
                }
              }}
            />
          </Grid>
          <Grid item xs={12} style={{ display:"flex", justifyContent:"center", alignItems:"center" }}>
            <CustomInput
              label="Confirmar contraseña*"
              name="confirmPassword"
              control={control}
              error={incorrectPasswords ? {
                password: {
                  message: "",
                  type: "required"
                },
                confirmPassword: {
                  message: "",
                  type: "required"
                }
              } : {}}
              type={showConfirmPassword ? "password" : "text"}
              onValidate={(e)=>handleConfirmPasswordChange(e)}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              InputPropsParam={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onMouseDown={() => setShowConfirmPassword(!showConfirmPassword)}
                      size="small"
                    >
                      {showIconConfirmPassword && (showConfirmPassword ? <VisibilityIcon /> : <VisibilityOffIcon />)}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              classes={classes.typeInput}
              autoFocus={false}
              inputProps={{
                style: !showConfirmPassword ? {
                  fontFamily: 'Montserrat',
                } : {
                  letterSpacing: "3px",
                  WebkitTextStroke: "0.5px black",
                }
              }}
            />
          </Grid>
          <Grid>
            <br />
            <Typography align="left" className={classes.Typography}>Tu contraseña debe tener como mínimo:</Typography>
            <FormControlLabel
              control={
                <Checkbox
                  checked={passwordErrors.upper}
                  color="primary"
                  className={classes.checkBox}
                  checkedIcon={<CheckendBoxIcon color={theme.palette.primary.main} width={20} height={20} pathColor={theme.typographyText.pathColor} />}
                  icon={<CheckBoxIcon color={theme.passwordCheckColor.borderInput} width={20} height={20} />}

                />
              }
              label={
                <Typography className={classes.Typography}>Una mayúscula</Typography>
              }
              className={classes.displayForm}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={passwordErrors.lower}
                  color="primary"
                  className={classes.checkBox}
                  checkedIcon={<CheckendBoxIcon color={theme.palette.primary.main} width={20} height={20} pathColor={theme.typographyText.pathColor}/>}
                  icon={<CheckBoxIcon color={theme.passwordCheckColor.borderInput} width={20} height={20} />}
                />
              }
              label={
                <Typography className={classes.Typography}>Una minúscula</Typography>
              }
              className={classes.displayForm}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={passwordErrors.number}
                  color="primary"
                  className={classes.checkBox}
                  checkedIcon={<CheckendBoxIcon color={theme.palette.primary.main} width={20} height={20} pathColor={theme.typographyText.pathColor}/>}
                  icon={<CheckBoxIcon color={theme.passwordCheckColor.borderInput} width={20} height={20} />}
                />
              }
              label={
                <Typography className={classes.Typography}>Un número</Typography>
              }
              className={classes.displayForm}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={passwordErrors.specialChar}
                  color="primary"
                  className={classes.checkBox}
                  checkedIcon={<CheckendBoxIcon color={theme.palette.primary.main} width={20} height={20} pathColor={theme.typographyText.pathColor}/>}
                  icon={<CheckBoxIcon color={theme.passwordCheckColor.borderInput} width={20} height={20} />}
                />
              }
              label={
                <Typography style={{textAlign: 'left'}} className={classes.Typography}>
                  Un carácter especial
                </Typography>
              }

              className={classes.displayForm}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={passwordErrors.length}
                  color="primary"
                  className={classes.checkBox}
                  checkedIcon={<CheckendBoxIcon color={theme.palette.primary.main} width={20} height={20} pathColor={theme.typographyText.pathColor}/>}
                  icon={<CheckBoxIcon color={theme.passwordCheckColor.borderInput} width={20} height={20} />}
                />
              }
              label={
                <Typography className={classes.Typography}>Entre 12 y 16 caracteres</Typography>
              }
              className={classes.displayForm}
            />
          </Grid>
          {isErrorBox && (
            <ErrorBoxUko value={errorBox}></ErrorBoxUko>
          )}
          <OwnButton
            style={{
              color: showButton ? theme.buttonUko.buttonUkoBackgroundDisabled : theme.buttonUko.buttonUkoBackgroundSuccess,
              backgroundColor: showButton ? theme.buttonUko.buttonUkoBackgroundDisabled : theme.buttonUko.buttonUkoBackgroundActive
            }}
            loading={loading}
            type="submit"
          >
            <Typography style={{
              fontFamily: 'Montserrat',
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'none',
              letterSpacing: '0.0px',
              color: showButton ? theme.buttonUko.buttonUkoColorDisabled : theme.buttonUko.buttonUkoBackgroundSuccess,
            }}
            >
              {loading ? (
                <CircularProgress size={14} color={theme.palette.secondary.light} />
              ) : (
                formState.isNewUser ? "Activar cuenta" : "Cambiar contraseña"
              )}
            </Typography>
          </OwnButton>
          {!formState.isNewUser ? (
            <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }} className={classes.gridReset}>
              <Typography>
                <OwnLink
                  to="/login"
                  onClick={onLinkGoToLogin}
                >
                  Iniciar sesión
                </OwnLink>
              </Typography>
            </Grid>
          ):(null)}
        </Grid>
      </form>
      <div style={{ display: 'flex', flexFlow: 'wrap', justifyContent: 'space-between', marginTop: '24px', marginBottom: '24px' }} ></div>
      <Box className={classes.version}>
        <p>{versionMessage}</p>
      </Box>
    </AuthenticationLayoutUko>
  );
};

const useStyles = makeStyles((theme) => ({
  typeInput: {
    '& .MuiOutlinedInput-root': {
      position: 'relative',
      borderRadius: '8px',
      width: '486px',
      height: '56px',
      backgroundColor: theme.InputUko.backgroundColor,
      [theme.breakpoints.down("xs")]: {
        width: "320px",
      },
    },
    "& .MuiOutlinedInput-input": {
      fontWeight: 500,
      color: theme.InputUko.colorInputLetter
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "8px",
      borderColor: theme.InputUko.borderInput,
      fontFamily: 'Montserrat',
    },
    "& .MuiInputLabel-root": {
      fontFamily: 'Montserrat',
      fontWeight: 500,
      color: theme.InputUko.colorLabel,
      fontSize: '16px',
      marginTop: '7px',
    },
    "& .MuiInputLabel-root.Mui-focused": {
      fontWeight: 600,
      color: theme.InputUko.colorLabelFocus,
    },
    "& .MuiSvgIcon-root": {
      color: theme.InputUko.colorIcon,
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.error.dark,
    },
    "& .MuiFormLabel-root.Mui-error": {
      color: theme.palette.error.dark,
    },
    "& .MuiInputLabel-shrink": {
      margin: "0 auto",
      position: "absolute",
      top: "1px",
    },
  },
  checkBox: {
    color: theme.passwordCheckColor.borderInput,
    "&.MuiCheckbox-colorPrimary.Mui-checked": {
      color: theme.palette.primary.main,
    }
  },
  displayForm:{
    display: 'flex',
    alignItems: 'center',
    margin: '2px 5px 0px 0px'
  },
  Typography:{
      color: theme.typographyText.textColor,
      fontFamily: 'Montserrat',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '16px'
  },
  gridReset: {
    [theme.breakpoints.down("xs")]: {
      width: "320px",
    },
  },
  version: {
    fontSize: '14px',
    fontFamily: 'Montserrat',
    fontWeight: 500,
    color: theme.versionUko.colorVersionLabel,
    position: 'absolute',
    bottom: '15px',
    left: '50%',
    right: '0',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      position: 'static',
    },
    '@media (max-height: 620px)':{
      position: 'static',
    }
  }
}));

ChangePasswordUko.propTypes = {
  assignPassword: PropTypes.func.isRequired,
  authReducer: PropTypes.object.isRequired,
  tokenValidation: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
  getVersionApp: state.applicationsReducer.getVersionApp,
});

export default connect(mapStateToProps, {
  assignPassword,
  tokenValidation,
  getVersionAppAction,
  clearAuthenticationResponse,
})(ChangePasswordUko);